import { render, staticRenderFns } from "./MaxWidth.vue?vue&type=template&id=40eb1450&"
import script from "./MaxWidth.vue?vue&type=script&lang=js&"
export * from "./MaxWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports